<template>
  <div class="recruit-content">
    <div class="recruit-title">
      <img src="@/assets/images/icon/title-left.png" alt />
      <div class="text">人才招聘</div>
      <img src="@/assets/images/icon/title-right.png" alt />
    </div>
    <div class="recruit-description">
      <div class="fl">
        <div class="text">加入我们</div>
        <div class="btn" @click="joinUs">JOIN US</div>
      </div>
      <div class="fr">
        <img src="@/assets/images/icon/recruit.jpeg" alt />
      </div>
    </div>
    <Modal v-model="positionListShow" width="1000" :mask-closable="false">
      <div slot="header" class="modal-header">职位列表</div>
      <list />
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import list from "./position/PositionList";
export default {
  components: {
    list,
  },
  data() {
    return {
      positionListShow: false,
    };
  },
  methods: {
    joinUs() {
      this.positionListShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
.recruit-content {
  width: 100%;
}
.recruit-title {
  height: 50px;
  display: flex;
  align-items: center;
  img {
    width: 300px;
    height: 12px;
  }
  .text {
    flex: 1;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #2d8cf0;
  }
}
.recruit-description {
  width: 100%;
  display: flex;
  .fl {
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text {
      width: 100%;
      margin: 30px 0;
      text-align: center;
      font-size: 20px;
      color: #666;
    }
    .btn {
      width: 200px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      text-align: center;
      border: 1px solid #2d8cf0;
      border-radius: 10px;
      color: #2d8cf0;
    }
    .btn:hover {
      font-size: 20px;
      cursor: pointer;
    }
  }
  .fr {
    flex: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 350px;
      height: 350px;
      border-radius: 50%;
    }
  }
}
.modal-header {
  text-align: center;
}
</style>